import React, { useState, useEffect } from 'react';
import axios from 'axios';

const VerifyEmail = () => {
  const [status, setStatus] = useState('verifying');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');

    if (!token) {
      setStatus('error');
      setMessage('Invalid verification link.');
      return;
    }

    const verify = async () => {
      try {
        await axios.get(`${process.env.REACT_APP_API_URL}/api/auth/verify?token=${token}`);
        setStatus('success');
      } catch (err) {
        setStatus('error');
        setMessage(err.response?.data?.error || 'Verification failed. The link may have expired.');
      }
    };

    verify();
  }, []);

  return (
    <div style={{
      minHeight: '100vh', background: '#0a0a0a',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: 'Jost, sans-serif', padding: '24px',
    }}>
      <div style={{ textAlign: 'center', maxWidth: '480px', width: '100%' }}>

        {/* Icon */}
        <div style={{
          width: '72px', height: '72px',
          border: `1px solid ${status === 'success' ? '#4a7a4a' : status === 'error' ? '#7a3030' : '#2a2a2a'}`,
          borderRadius: '50%',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 32px', fontSize: '1.8rem',
          transition: 'border-color 0.3s',
        }}>
          {status === 'verifying' ? '✉' : status === 'success' ? '✓' : '✕'}
        </div>

        <p style={{ fontSize: '0.65rem', letterSpacing: '0.4em', textTransform: 'uppercase', color: '#c9a96e', marginBottom: '24px' }}>
          Flakon
        </p>

        {status === 'verifying' && (
          <>
            <h1 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '2.2rem', fontWeight: 300, color: '#f5f0eb', marginBottom: '16px' }}>
              Verifying...
            </h1>
            <p style={{ fontSize: '0.8rem', color: '#6b6460', letterSpacing: '0.05em' }}>
              Please wait a moment.
            </p>
          </>
        )}

        {status === 'success' && (
          <>
            <h1 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '2.2rem', fontWeight: 300, color: '#f5f0eb', marginBottom: '16px' }}>
              You're verified.
            </h1>
            <p style={{ fontSize: '0.88rem', color: '#6b6460', lineHeight: 1.8, marginBottom: '12px' }}>
              Your account is now active.
            </p>
            <p style={{ fontSize: '0.88rem', color: '#a09890', lineHeight: 1.8, marginBottom: '40px' }}>
              Head back to the tab or device where you signed up — it should automatically continue from where you left off.
            </p>
            <div style={{
              background: '#0f0f0f', border: '1px solid #1e1e1e',
              padding: '20px 24px', marginBottom: '32px',
            }}>
              <p style={{ fontSize: '0.65rem', letterSpacing: '0.2em', textTransform: 'uppercase', color: '#3a3a3a', marginBottom: '8px' }}>
                Or continue here
              </p>
              <a href="/" style={{
                display: 'inline-block', background: '#c9a96e',
                color: '#0a0a0a', textDecoration: 'none',
                padding: '14px 32px', fontSize: '0.65rem',
                letterSpacing: '0.2em', textTransform: 'uppercase',
              }}>
                Enter Flakon
              </a>
            </div>
            <p style={{ fontSize: '0.72rem', color: '#2a2a2a', lineHeight: 1.7 }}>
              You can close this tab if you're continuing on another device.
            </p>
          </>
        )}

        {status === 'error' && (
          <>
            <h1 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '2.2rem', fontWeight: 300, color: '#f5f0eb', marginBottom: '16px' }}>
              Something went wrong.
            </h1>
            <p style={{ fontSize: '0.8rem', color: '#6b6460', letterSpacing: '0.05em', marginBottom: '32px' }}>
              {message}
            </p>
            <a href="/" style={{
              display: 'inline-block', border: '1px solid #2a2a2a',
              color: '#a09890', textDecoration: 'none',
              padding: '14px 32px', fontSize: '0.65rem',
              letterSpacing: '0.2em', textTransform: 'uppercase',
            }}>
              Back to Flakon
            </a>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;